<template>
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 20H32"
            stroke="#6B7280"
            stroke-width="3"
        />
        <path
            d="M8 10H32"
            stroke="#6B7280"
            stroke-width="3"
        />
        <path
            d="M8 30H16"
            stroke="#6B7280"
            stroke-width="3"
        />
        <path
            d="M25.0005 24.5151L19.7578 29.7578L25.0005 35.0005"
            stroke="#6B7280"
            stroke-width="3"
        />
        <path
            d="M32 30H20"
            stroke="#6B7280"
            stroke-width="3"
        />
    </svg>
</template>
